export type GradebookCourseStatus = 'Reprobado' | 'Aprobado' | 'En progreso';

export interface GradebookCellGrade {
  status?: string | null;
  percentage?: number | null;
  score?: number | null;
}

export function gradeCellPercentage(
  grade: { percentage?: number | null; score?: number | null } | null | undefined,
): number | null {
  if (grade?.percentage == null || Number.isNaN(grade.percentage)) return null;
  return grade.percentage;
}

export function gradeStatusBadge(
  status?: string | null,
): { label: string; variant: 'success' | 'danger' | 'secondary' | 'primary' } | null {
  switch (status) {
    case 'passed':
      return { label: 'Aprobado', variant: 'success' };
    case 'failed':
      return { label: 'Reprobado', variant: 'danger' };
    case 'pending':
      return { label: 'Pendiente', variant: 'secondary' };
    case 'graded':
      return { label: 'Calificada', variant: 'primary' };
    default:
      return null;
  }
}

export interface SummaryEntry {
  kind?: string | null;
  grade?: GradebookCellGrade | null;
}

/** Las actividades H5P y los ítems informativos no entran en el promedio ni en el estado. */
export function summarizeStudent(entries: SummaryEntry[]): {
  average: number | null;
  partial: boolean;
  status: GradebookCourseStatus;
} {
  const grades = entries
    .filter((entry) => entry.kind !== 'h5p' && entry.kind !== 'informative')
    .map((entry) => entry.grade);
  const values = grades
    .map((grade) => gradeCellPercentage(grade))
    .filter((value): value is number => value != null);
  const average = values.length > 0 ? values.reduce((total, value) => total + value, 0) / values.length : null;
  const partial = values.length > 0 && values.length < grades.length;
  return {
    average,
    partial,
    status: gradebookCourseStatus(grades),
  };
}

/** Reprobado si hay algún failed. Aprobado solo cuando todas las celdas tienen nota y están passed. */
export function gradebookCourseStatus(
  grades: Array<GradebookCellGrade | null | undefined>,
): GradebookCourseStatus {
  if (grades.some((grade) => grade?.status === 'failed')) return 'Reprobado';
  const allPassed =
    grades.length > 0 &&
    grades.every((grade) => grade != null && grade.percentage != null && grade.status === 'passed');
  return allPassed ? 'Aprobado' : 'En progreso';
}
